define(
({
  "alert": "Alerta",
  "okay": "OK"
})
);
